Components.ContactCard = {
    bindings: {
        contact: '=',
        currency: '=',
        onDeleteContact: '&'
    },
    // @ngInject
    controller: function ContactCardComponentController($scope, $element, $attrs, $state, UsersManager, EventService, UserService, $translate, ContactsManager, AppStates, PopupMessageService, UiPersistenceService, AnalyticsService) {

        this.$onInit = function $onInit() {
            this.currUser = UsersManager.getCurrUser();
            this.EventService = EventService;
            this.UserService = UserService;
            this.PopupMessageService = PopupMessageService;
            this.UiPersistenceService = UiPersistenceService;
            this.$state = $state;
            this.ContactsManager = ContactsManager;
            this.AppStates = AppStates;
            this.AnalyticsService = AnalyticsService;

            var self = this;

            // When coming from gift card email, this param tell the card to be open
            if(!!this.$state.params.giftCard) {
                this.showMoreClicked();
            }

            $scope.$watch('$ctrl.contact.workspaces_count', function (val) {
                var plural = self.contact.workspaces_count > 1 ? 's' : '';
                $translate('DASHBOARD.CONTACTS.LABELS._CONNECTED_IN_', {
                    workspaces_count: self.contact.workspaces_count,
                    plural: plural
                }).then(function (text) {
                    self.projectsCountText = text;
                });
            }).bind(this);

            this.voucherCountText = $translate.instant('DASHBOARD.CONTACTS.CARD.VOUCHER._TITLE_');
        };

        this.addProject = function addProject(userId) {
            var config = {userId: userId };
            this.EventService.createEventCommand(config);
        };

        this.showMoreClicked = function showMoreClicked() {
            this.showMore = !this.showMore;
            this.ContactsManager.getWorkspaceConnectionsForContact(this.contact);
        };

        this.clickEditContact = function clickEditContact() {
            this.UserService.editContact(this.contact.user);
        };

        this.goToWorkspace = function goToWorkspace(workspace_id, event_id) {
            this.$state.go(this.AppStates.root_core_navigation_event_workspace_feed, {
                workspace_id: workspace_id,
                event_id: event_id
            });
        };

        this.deleteContact = function deleteContact() {
            this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, {
                translationId: 'FREQUENT_MESSAGES._CONFIRM_DELETE_',
                interpolateParams: { type: 'contact' }
            }).then(function ok() {
                var analyticsArgs = {
                    contact_email: this.contact.user.email,
                    contact_id: this.contact._id
                };

                this.ContactsManager.deleteContact(this.contact).then(function success() {
                    this.contact.isDeleted = true;
                    this.onDeleteContact(this.contact);
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.delete_contact, analyticsArgs);

                }.bind(this)).catch(function error(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.delete_contact_unsuccessful, analyticsArgs);
                }.bind(this));
            }.bind(this));
        };

        this.togglePreferred = function togglePreferred(event) {
            event.stopPropagation();
            event.preventDefault();

            var pvlPopupHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.ContactsPreferredPopup) || {};
            var wasPopupDisplayed = pvlPopupHash.hidePreferredPopup;

            if ( !this.contact.is_preferred && !wasPopupDisplayed ) {
                pvlPopupHash.hidePreferredPopup = true;
                this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.ContactsPreferredPopup, pvlPopupHash);

                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.none, {
                    translationId: 'CONTACTS.PREFERRED_VENDOR._VENDOR_ADDED_',
                    interpolateParams: {name: this.contact.user.full_name}

                }, null, 'FREQUENT_BUTTONS._OK_');
            }

            this.ContactsManager.updatePreferredVendorContact(this.contact, !this.contact.is_preferred)
                .then(function success(resp){
                    this.contact.is_preferred = resp.data.is_preferred;
                }.bind(this));

        };

        this.getProjectsLinkCTA = function getProjectsLinkCTA() {
            var cta;
            if(this.contact.workspaces.length === 1) {
                cta = 'Go to project';
            } else {
                cta = this.contact.workspaces.length + ' Projects';
            }
            return cta;
        };

        this.getGiftCardLinkCTA = function getGiftCardLinkCTA() {
            var cta;
            if(this.contact.gift_cards.length === 1) {
                cta = '1 Gift card';
            } else {
                cta = this.contact.gift_cards.length + ' Gift cards';
            }
            return cta;
        };

        this.projectLinkClicked = function projectLinkClicked() {
            if(this.contact.workspaces.length === 1) {
                var workspace = this.contact.workspaces[0];
                this.goToWorkspace(workspace._id, workspace.event_id);
            } else {
                this.showMoreClicked();
            }
        };

        this.giftCardLinkClicked = function giftCardLinkClicked() {
            this.showMoreClicked();
        };

        this.toggleShowVoucherQuestions = function toggleShowVoucherQuestions(voucher) {
            if (!voucher.showVoucherQuestions) {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.voucher_see_questions, {
                    gift_card_id: voucher._id
                });
            }
            voucher.showVoucherQuestions = !voucher.showVoucherQuestions
        };

        this.formatAnswer = function getAnswerFormat(answer) {
            if (Array.isArray(answer)) {
                return answer.join(', ');
            }

            return answer || "N/A";
        };
        
    },
    name: 'hbContactCard',
    templateUrl: 'angular/app/modules/common/ui_components/contact_card/contact_card.html',
};
